/**
 * Valideringsfunktioner för formulär
 * Återanvändbara valideringsfunktioner för React Hook Form
 */

/**
 * Validerar lösenord med flera krav
 * @param {string} value Lösenordet som ska valideras
 * @returns {string|true} Felmeddelande eller true om validering lyckas
 */

export const validatePassword = (value) => {
  if (!value) return "Lösenord är obligatoriskt";
  if (value.length < 8) return "Lösenordet måste vara minst 8 karaktärer";
  if (!/[A-Z]/.test(value))
    return "Lösenordet måste innehålla minst en stor bokstav";
  if (!/[!@#$%^&*]/.test(value))
    return "Lösenordet måste innehålla minst ett specialtecken";
  return true;
};

/**
 * Validerar att lösenord matchar
 * @param {string} value Lösenordet som ska valideras
 * @param {string} password Det ursprungliga lösenordet
 * @returns {string|true} Felmeddelande eller true om validering lyckas
 */

export const validateRepeatPassword = (value, password) => {
  return value === password || "Lösenord matchar ej";
};

/**
 * Validerar e-postadress
 * @param {string} value E-postadressen som ska valideras
 * @returns {string|true} Felmeddelande eller true om validering lyckas
 */

export const validateEmail = (value) => {
  if (!value) return "E-postadress är obligatorisk";
  if (!/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,5}$/.test(value)) {
    return "Ogiltig e-postadress";
  }
  return true;
};

/**
 * Validerar att e-postadresser matchar
 * @param {string} value E-postadressen som ska valideras
 * @param {string} email Den ursprungliga e-postadressen
 * @returns {string|true} Felmeddelande eller true om validering lyckas
 */

export const validateRepeatEmail = (value, email) => {
  // Compare case-insensitively so users can mix uppercase/lowercase
  if (typeof value !== "string" || typeof email !== "string")
    return "E-postadress matchar ej";
  return (
    value.trim().toLowerCase() === email.trim().toLowerCase() ||
    "E-postadress matchar ej"
  );
};

export const validateOrganizationNumber = (organization) => {
  if (!organization) return "Organisationsnummer är obligatoriskt.";
  if (!/^[0-9]{6}-?[0-9]{4}$/.test(organization)) {
    return "Ogiltigt organisationsnummer. Formatet ska vara 000000-0000.";
  }
  return true;
};

// Validerar svenska mobilnummer.
// Tillåter format:
// - 0701234567
// - +46701234567
// Mellanslag ignoreras.
export const validatePhoneNumber = (phone) => {
  const cleaned = phone.replace(/\s/g, ""); // ta bort mellanslag
  return /^(?:0(70|72|73|76|79)|\+46(70|72|73|76|79))\d{7}$/.test(cleaned);
};

// Används för frivilliga telefonfält.
export const validateOptionalPhoneNumber = (value) => {
  if (!value || value.trim() === "") return true;

  return (
    validatePhoneNumber(value) || " Vänligen ange ett giltigt telefonnummer"
  );
};

// Normaliserar telefonnummer till internationellt format (+46).
// Ex: 0701234567 -> +46701234567
// Används innan vi skickar till backend.
export const normalizePhone = (phone) => {
  const noSpaces = phone.replace(/\s/g, "");

  // Om användaren skrev 070..., konvertera till +4670...
  if (noSpaces.startsWith("0")) {
    return "+46" + noSpaces.slice(1);
  }

  return noSpaces;
};
